<!-- ================管理端-研学活动详情====================-->
<template>
    <div class="admin-create-container">
        <div class="admin-head-container">
            <div class="admin-left-head-container" @click="backList">
                <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#377f7f" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
            </div>
            <div class="admin-right-head-container">研学活动详情</div>
        </div>
        <div class="create-content-container" v-loading="loading">
            <div class="event-base-info-container">
                <div class="event-part1-l">
                    <div class="excursion-section-title">一、活动基本信息</div>
                    <div class="event-info-item-auto">
                        <span class="item-span">活动名称：</span>
                        {{form.excursionTitle}}
                    </div>
                    <div class="event-info-item-auto" v-if="form.excursionSubtitle">
                        <span class="item-span">副标题：</span>
                        {{form.excursionSubtitle}}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">所属研学营：</span>
                        {{campName(form.campKey)}}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">活动主题：</span>
                        {{form.excursionTheme}}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">参与对象：</span>
                        {{form.excursionAudienceName}}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">查看平台：</span>
                        {{form.businessPlatformName}}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">活动时间：</span>
                        {{timestampToTime(form.beginTime)}} 至 {{timestampToTime(form.endTime)}}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">活动地点：</span>
                        {{form.excursionAddress}}
                    </div>

                    <div class="excursion-section-title">二、研学核心内容</div>
                    <div class="event-info-item-auto">
                        <span class="item-span">知识研学：</span>
                        {{form.knowledgeExcursion}}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">实践体验：</span>
                        {{form.practicalExperience}}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">素养提升：</span>
                        {{form.qualityImprove}}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">安全保障：</span>
                        {{form.safetyAssurance}}
                    </div>

                    <div class="excursion-section-title">三、活动介绍</div>
                    <div class="excursion-overview" v-html="form.excursionOverview"></div>

                    <div class="excursion-section-title">四、研学手册</div>
                    <div class="b-file-info-container">
                        <div class="b-file-list">
                            <div class="b-file-item" v-for="item in fileList" :key="item.fileUrl">
                                <div class="b-file-title" @click="downloadFile(item)">{{ item.fileName }}</div>
                                <div class="b-file-view" title="预览" v-if="item.imgUrl">
                                    <el-image @click="handleFileStatus(item.status)" class="b-file-icon" style="margin-top: 2px"
                                              :src="require('@/assets/file/file_view_color.png')"
                                              :preview-src-list="gainFileImgList(item.imgUrl, item.pages)">
                                    </el-image>
                                </div>
                                <div class="b-file-download" title="下载" @click="downloadFile(item)">
                                    <img class="b-file-icon" style="margin-top: 3px" src="../../../assets/file/file_download.png" alt="">
                                </div>
                            </div>
                            <div v-if="fileList.length===0" class="data-empty">
                                <div class="empty-icon"><img src="../../../assets/image/data_empty.png" alt="" /></div>
                                <div class="empty-title">暂无附件</div>
                            </div>
                        </div>
                    </div>

                    <div class="excursion-section-title">五、联系方式</div>
                    <div class="event-info-item-auto" style="white-space: pre-wrap;">
                        {{form.contactInfo}}
                    </div>
                </div>
                <div class="event-part1-r">
                    <div class="event-info-item-auto">
                        <span class="item-span">活动封面：</span>
                    </div>
                    <div class="event-base-info-cover">
                        <img class="img-100" :src="form.excursionCover" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {infoExcursion} from "@/api/admin/excursion";
import {queryDict} from "@/api/admin/dict";
import {timestampToTime} from "@/utils/date";
import {downloadFile} from "@/utils/download";

export default {
    components: {},
    name: "excursionDetail",
    data() {
        return {
            timestampToTime,
            loading: true,
            excursionId: '',
            campList: [],
            fileList: [],
            // 表单参数
            form: {},
        }
    },
    computed: {},
    watch: {},
    created() {
        this.handleQueryDict();
        if (this.$route.query.excursionId) {
            this.excursionId = this.$route.query.excursionId;
            this.queryExcursionInfo();
        }
    },
    mounted() {},
    methods: {
        backList() {
            this.$router.push({
                path: "/excursion",
            });
        },
        handleQueryDict() {
            queryDict({ code: 'museum_camp' }).then(res => {
                if (res.data.code === 1) {
                    this.campList = res.data.data;
                }
            })
        },
        campName(campKey) {
            const camp = this.campList.find(item => item.dictKey === campKey);
            return camp ? camp.dictValue : campKey;
        },
        queryExcursionInfo() {
            infoExcursion({ excursionId: this.excursionId }).then(res => {
                this.loading = false;
                if (res.data.code === 1) {
                    this.form = res.data.data;
                    this.fileList = [];
                    if (this.form.fileList && this.form.fileList.length > 0) {
                        this.fileList = this.form.fileList;
                    } else if (this.form.fileUrls) {
                        this.form.fileUrls.split(',').forEach(e => {
                            this.fileList.push({
                                fileName: e.substring(e.lastIndexOf('/') + 1),
                                fileUrl: e,
                            })
                        })
                    }
                } else {
                    this.$message.error("操作失败")
                }
            })
        },
        downloadFile(item) {
            downloadFile(item.fileUrl, item.fileName)
        },
        handleFileStatus(status) {
            if (status === 1) {
            } else {
                this.$message.info("文件正在处理，请稍后刷新预览")
            }
        },
        gainFileImgList(baseUrl, page) {
            const list = [];
            for (let i = 1; i <= page; i++) {
                list.push(baseUrl + '/' + i + '.png');
            }
            return list;
        },
    },
}
</script>
<style>
.event-base-info-container{
    width: 100%;
    height: auto;
    padding-bottom: 10px;
    display: flex;
}
.event-part1-l{
    width: calc(100% - 270px);
    height: 100%;
    padding-right: 20px;
    box-sizing: border-box;
}
.event-info-item-auto{
    width: 100%;
    height: auto;
    line-height: 25px;
    display: flex;
    font-size: 15px;
    margin-top: 5px;
}
.event-part1-r{
    width: 270px;
    height: 100%;
}
.event-base-info-cover{
    width: 270px;
    height: 152px;
    box-sizing: border-box;
    img{
        width: 100%;
        height: 100%;
    }
}
.item-span{
    font-weight: bold;
    color: #377f7f;
}
.b-file-info-container{
    width: 100%;
    height: auto;
}
.b-file-list{
    width: calc(100% - 60px);
    height: auto;
}
.b-file-item{
    display: flex;
    height: 30px;
    width: 100%;
    box-sizing: border-box;
}
.b-file-item:hover{
    color: #377f7f!important;
    font-weight: bold;
}
.b-file-title{
    width: calc(100% - 60px);
    height: 100%;
    font-size: 15px;
    line-height: 30px;
    cursor: pointer;
    padding-left: 20px;
    box-sizing: border-box;
}
.b-file-view{
    width: 30px;
    height: 100%;
}
.b-file-download{
    width: 30px;
    height: 100%;
}
.b-file-icon{
    width: 20px;
    height: 20px;
    cursor: pointer;
}
.excursion-overview {
    margin-left: 10px;
    margin-top: 5px;
    width: calc(100% - 10px);
    font-size: 15px;
    line-height: 25px;
    img {
        max-width: 100%;
    }
    table {
        width: 100%;
        border-collapse: collapse;
    }
}
@media (max-width: 1024px) {
    .event-base-info-container { flex-direction: column; }
    .event-part1-l { width: 100%; padding-right: 0; }
    .event-part1-r { width: 100%; margin-top: 20px; }
}
</style>
